import TofuProduct from 'models/TofuProduct'

export const packagingInitialState = {
  category: TofuProduct.category,
  subCategory: TofuProduct.subCategory,
  Calcium: TofuProduct.Calcium,
  IsPlainRefrigerated: TofuProduct.IsPlainRefrigerated,
  Texture: {
    value: TofuProduct.Texture,
    label: 'Texture',
  },
  OtherTexture: TofuProduct.OtherTexture,
  PackageSize: TofuProduct.PackageSize,
  Organic: TofuProduct.Organic,
}

export const textureOptions = [
  {
    value: '',
    label: 'Texture',
    isDisabled: true,
  },
  {
    value: 'Silken',
    label: 'Silken',
  },
  {
    value: 'Soft',
    label: 'Soft',
  },
  {
    value: 'Medium Firm',
    label: 'Medium Firm',
  },
  {
    value: 'Firm',
    label: 'Firm',
  },
  {
    value: 'Extra Firm',
    label: 'Extra Firm',
  },
  {
    value: 'Other',
    label: 'Other',
  },
]
